

<template>
  <div class="container" style="margin-top: 42px;">
    <el-row class="faq-container" style="padding:0 110px 48px 0;">
      <el-col v-for="(faq, index) in faqs" :key="index" :span="12">
        <div class="faq-item" @click="handleClick(faq)">
          <h3 class="show-ellipsis">{{ faq.question }}</h3>
            <div class="faq-answer show-ellipsis">
               <i>答</i> A: {{ faq.answer }}
            </div>
        </div>
      </el-col>
    </el-row>
  </div>

</template>
<script>

export default {
props:{
  activeName:{
    type:String
  }
},
components: {

},
created() {
 
},
data() {
  return {
    faqs: [
    {
      id:'1',
      question: '【国内报关】品牌申报，我们发的不是什么知名品牌，为什么也要申报？',
      answer: '品牌申报是海关对于货物申报的一项基本要求，跟这个品牌是否知名没有关系。如该品牌在海关有过备案（一般会带R和TM标识），报关时还需提供品牌授权书；如无海关备案，不需提供品牌授权书，如实申报品牌即可。'
    },
    {
      id:'2',
      question: '【清关】什么叫一般贸易出口报关,我公司没有进出口权我的货物是怎么出去的？',
      answer: '我国的出口贸易方式有很多种，常见的包括：一般贸易/来料加工/旅游购物/保税仓储/租赁贸易/跨境电商（B2C项下）等等。对于FBA头程物流的出口，基本归属于一般贸易报关方式（代号0110）的范畴，也叫正式报关出口。申报单位需向海关提交：出口货物报关单；报关委托书；销售合同；装箱单；发票等整套单证。大部分中小卖家不具备进出口权，也不具备出口退税的条件，为了方便快捷，通常做法是购买别的进出口企业的核销单以别的进出口企业的名义出口，业内称之为“代理出口”。'
    },
    {
      id:'3',
      question: '【VAT申报】英国VAT申报中，C79和C88有什么区别？',
      answer: 'C79是每个月进口报税的汇总，海关会在次月寄信件到注册VAT时提供的通信地址；C88是每一次进口清关的税单，由清关的报关行可以拿到；季度申报时，税局要求提供C79进行申报。'
    },
    {
      id:'4',
      question: '【关税】如何查询亚马逊各站点所在国的产品进口关税税率？',
      answer: '欧洲产品进口关税查询：http://ec.europa.eu,美国产品进口关税查询：https://hts.usitc.gov,加拿大产品进口关税查询：http://www.cbsa-asfc.gc.ca,日本产品进口关税查询：http://www.customs.go.jp,澳洲产品进口关税查询：https://ftaportal.dfat.gov.au'
    },
    {
      id:'5',
      question: '【海关】如何理解产品的海关编码（HS Code），编码归类的主要依据是什么？',
      answer: '海关编码其实是依据《商品名称及编码协调制度的国际公约》（简称HS），用科学系统的方法将商品分类。HS采用六位数编码，把全部国际贸易商品分为22类，98章。章以下再分为目和子目。商品编码第一、二位数码代表“章”，第三、四位数码代表“目”（Heading），第五、六位数码代表“子目”（Subheading）。前6位数是HS国际标准编码，后2-4位数是各个国家海关按照实际情况再进行延伸，所以大家才会常说前6位海关编码是国际通用的。'
    },
    {
      id:'6',
      question: '【头程物流】DDP与DDU分别是什么意思？',
      answer: 'DDP即完税后交货，通俗的理解为出口商在起运港预付了税金（包含关税和VAT等）；DDU即未完税交货，可理解为由进口商在目的港缴税。FBA头程运输中，如果卖家在国外没有自己的公司或银行账户来及时缴税，则需要通过物流公司来做DDP条款的完税交货（注意：亚马逊不能作为进口商，不会为卖家缴税）。'
    },
    // 其他的FAQ对象...
  ]
  };
},
methods: {
  handleClick(item){
      console.log(item,this.activeName,'item,activeName')
      this.$router.push({
        path:'/questionDetail',
        query:{
          id:item.id,
          activeName:this.activeName
        }
      })
    }
}

};
</script>
<style src="../index.css" scoped>


</style>